import fetchApi from '~/common/fetchApi';

export const fetchAvailablePhones = async (): Promise<{
    availableWaAccounts: number;
    availableTgAccounts: number;
    availableMaxAccounts: number;
}> => {
    return await fetchApi.get<{
        availableWaAccounts: number;
        availableTgAccounts: number;
        availableMaxAccounts: number;
    }>('/account/availablePhones');
};

export type ExpireAccount = {
    order_id: number;
    type: 1 | 2 | 3 | 4 | 5 | 6;
    count: number;
    createTime: number;
    expireTime: number;
};

export const fetchExpiresAccounts = async (): Promise<ExpireAccount[]> => {
    return await fetchApi.get<ExpireAccount[]>('/account/expires');
};
